export  const sendBackShapes = (canvas) => {
    canvas._objects.forEach(e => {
        if (e.name === 'free-shape' || e.name === 'shape') {
            canvas.sendToBack(e);
        }
        // canvas.renderAll()
    })
}